export default __webpack_public_path__ + "static/media/有机物分析仪.7acb8469.png";